var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTabletSettings = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 31,
  viewBox: "0 0 30 31",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#C1C7D0",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-33.000000, -239.000000) translate(33.000000, 239.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.058 3.75c.861 0 1.626.55 1.898 1.368l.633 1.9c.54.243 1.052.54 1.527.883l1.965-.402c.843-.173 1.702.214 2.133.96l1.058 1.833c.43.745.336 1.683-.236 2.327l-1.33 1.5c.03.29.044.584.044.881 0 .297-.015.591-.044.88l1.33 1.501c.572.644.666 1.582.236 2.327l-1.058 1.834c-.43.745-1.29 1.132-2.133.96l-1.965-.403c-.475.343-.986.64-1.526.883l-.634 1.9c-.272.817-1.037 1.368-1.898 1.368h-2.116c-.861 0-1.626-.55-1.898-1.368l-.635-1.9c-.54-.244-1.05-.54-1.525-.883l-1.965.402c-.843.173-1.702-.214-2.133-.96l-1.058-1.833c-.43-.745-.336-1.683.236-2.327l1.33-1.5c-.03-.29-.044-.584-.044-.881 0-.297.015-.591.044-.88l-1.33-1.501c-.572-.644-.666-1.582-.236-2.327l1.058-1.834c.43-.745 1.29-1.132 2.133-.96l1.965.403c.475-.343.986-.64 1.526-.883l.634-1.9c.272-.817 1.037-1.368 1.898-1.368h2.116z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 1.5
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTabletSettings);
export default ForwardRef;